import { IEstadoAction, SET_ESTADOS } from '../actions/EstadosAction';
import { IEstado } from '../store/Models';

interface IEstadoState {
    estados: Array<IEstado>;
}

const initialState: IEstadoState = {
    estados: []
}

export const estadoReducer = (state = initialState, action: IEstadoAction): IEstadoState => {

    switch (action.type) {

        case SET_ESTADOS:

            const newState = {
                estados: action.estados
            };
            return { ...state, ...newState }
        default:
            return state;

    }
}